import React from 'react';
import { Modal } from 'react-bootstrap';
import { ModalFragmentProps } from '../../../constants/types';
import useAccountSecurityPromptContext from '../../../hooks/useAccountSecurityPromptContext';
import { FragmentModalHeader, HeaderButtonType } from '../fragments/modalHeader';

/**
 * The confirmation page of the change password modal flow.
 */
const ModalChangePasswordConfirmation: React.FC<ModalFragmentProps> = ({
  closeModal
}: ModalFragmentProps) => {
  const {
    state: { resources }
  } = useAccountSecurityPromptContext();

  /*
   * Component Markup
   */

  return (
    <React.Fragment>
      <FragmentModalHeader
        headerText={resources.Header.Success}
        buttonType={HeaderButtonType.CLOSE}
        buttonAction={closeModal}
        buttonEnabled
        headerInfo={null}
      />
      <Modal.Body>
        <div className='modal-shield' />
        <p>{resources.Description.ChangeYourPasswordSuccess}</p>
      </Modal.Body>
    </React.Fragment>
  );
};

export default ModalChangePasswordConfirmation;
